<template>
  <div class="Head fx4">
    <div class="logo" @click="hadnleLogo">
      <img
        src="https://staticdn.ht-s.cn/se/ciif/2022/logo.png"
        v-if="$store.state.clientWidth > 768"
        class="logo-img"
        alt=""
      />
      <img
        src="https://staticdn.ht-s.cn/se/ciif/2022/logo.png"
        v-if="$store.state.clientWidth <= 768"
        class="logo-img"
        alt=""
      />
    </div>
    <div v-if="$store.state.clientWidth > 768 && ismenu" class="header-pc">
      <div class="el-menu-demo">
        <div
          @click="handleSelect(index, item.path, item.Id, item.ispath, item.ga)"
          class="el-menu-item"
          :class="activeIndex == item.Id && $route.path !== '/Home/Live'? 'MenuActive' : ''"
          v-for="(item, index) in navList"
          :key="item.Id"
        >
          <div class="el_item">
            <span v-if="item.ispath">{{ item.title }}</span>
            <a v-else>{{ item.title }}</a>
          </div>
          <div class="menu_line"></div>
        </div>
      </div>
    </div>
    <div v-else class="header-m fx2">
      <el-collapse-transition>
        <div v-if="navMobile" class="nav_m">
          <div class="m_right_memu">
            <ul>
              <li
                @click="
                  handleSelect(index, item.path, item.Id, item.ispath, item.ga)
                "
                :class="activeIndex == item.Id  && $route.path !== '/Home/Live'? 'm_MenuActive' : ''"
                v-for="(item, index) in navList"
                :key="item.Id"
              >
                <span v-if="activeIndex == item.Id && $route.path !== '/Home/Live'"
                  >{{ item.title }}
                  <img
                    src="https://staticdn.ht-s.cn/se/ciif/2022/common/icon_next.png"
                    alt=""
                  />
                </span>
                <a v-else
                  >{{ item.title }}
                  <img src="https://staticdn.ht-s.cn/se/ciif/2023/common/icon_next1.png" alt="" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </el-collapse-transition>
    </div>
    <div class="user" v-if="ismenu">
      <div>
        <div class="header-person" v-if="islogin" @click="handleSelect(9, '/Home/Personal', 9, true, { event: 'trk', ec: 'Navi', ea: 'myarea', el: 'myarea', }) ">
          <div>你好，{{ userInfo.Name }}</div>
          <img src="https://staticdn.ht-s.cn/se/ciif/2022/common/icon_person.png" />
        </div>
        <div class="header-person" v-else>
          <div @click="Register" v-ga="{ event: 'trk', ec: 'Navi', ea: 'login', el: 'login' }">登录</div>
          <img @click="handleSelect(9, '/Home/Personal', 9, true, { event: 'trk', ec: 'Navi', ea: 'myarea', el: 'myarea', })" src="https://staticdn.ht-s.cn/se/ciif/2022/common/icon_person.png" alt="" />
        </div>
      </div>
      <div class="line" v-if="clientWidth <= 768"></div>
      <van-icon
        v-if="clientWidth <= 768 && !navMobile"
        name="wap-nav"
        size="30"
        class="icon-nav cur"
        @click="navState1"
      />
      <van-icon
        v-if="clientWidth <= 768 && navMobile"
        name="cross"
        size="30"
        class="icon-nav cur"
        @click="navState2"
      />
    </div>
  </div>
</template>

<script>
import { GetUserLogs } from "@/api/index.js";
import { ApiToken } from '@/utils/ApiToken'
console.log(ApiToken.surveyTime)
let flag = Date.now() >= new Date(ApiToken.surveyTime.replace(/-/g, "/")).getTime() ? true : false
export default {
  props: {
    ismenu: {
      type: Boolean,
      value: true,
    },
  },
  data() {
    return {
      activeIndex: 0,
      shows: false,
      navMobile: false,
      navList: [
        {
          title: "首页",
          path: "/Home/Index",
          items: [],
          Id: 0,
          ispath: true,
          ga: { event: "trk", ec: "Navi", ea: "homepage", el: "homepage" },
        },
        {
          title: "大会日程",
          path: "/Home/Index",
          items: [],
          Id: 1,
          ispath: false,
          ga: { event: "trk", ec: "Navi", ea: "agenda", el: "agenda" },
        },
        {
          title: "云导览",
          path: "/Home/Index",
          items: [],
          Id: 2,
          ispath: false,
          ga: { event: "trk", ec: "Navi", ea: "cloud", el: "onlinetour" },
        },
        {
          title: "新品展示",
          path: "/Home/Index",
          items: [],
          Id: 3,
          ispath: false,
          ga: { event: "trk", ec: "Navi", ea: "news", el: "newproducts" },
        },
        {
          title: "下载中心",
          path: "/Home/Index",
          items: [],
          Id: 4,
          ispath: false,
          ga: { event: "trk", ec: "Navi", ea: "download", el: "download" },
        },
        {
          title: "行业云展厅",
          path: "/Home/Index",
          items: [],
          Id: 5,
          ispath: false,
          ga: { event: "trk", ec: "Navi", ea: "showroom", el: "showroom" },
        },
        // {
        //   title: "有奖调研",
        //   path: "/Home/Survey",
        //   items: [],
        //   Id: 6,
        //   ispath: true,
        //   ga: { event: "trk", ec: "Navi", ea: "survey", el: "survey" },
        // },
        {
          title: "参会指南",
          path: "/Home/Index",
          items: [],
          Id: 7,
          ispath: false,
          ga: { event: "trk", ec: "Navi", ea: "guide", el: "guide" },
        },
        // {
        //   title: "个人中心",
        //   path: "/Home/Personal",
        //   items: [],
        //   Id: 9,
        //   ispath: true,
        //   ga: { event: "trk", ec: "Navi", ea: "myarea", el: "myarea" },
        // },
        // {
        //   title: "云相册",
        //   path: "/Home/CloudPhoto",
        //   items: [],
        //   Id: 8,
        //   ispath: true,
        //   ga: { event: "trk", ec: "navi", ea: "album" },
        // },
        {
          title: flag ? "云相册" : "个人中心",
          path: flag ? "/Home/CloudPhoto" : "/Home/Personal",
          items: [],
          Id: flag ? 8 : 9,
          ispath: true,
          ga: flag ? { event: "trk", ec: "navi", ea: "album" } : { event: "trk", ec: "Navi", ea: "myarea", el: "myarea" },
        },
      ],
    };
  },
  methods: {
    getActive() {
      if (this.$route.path == "/Home/Survey") {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        this.$store.commit("activeIndex", 6);
      }
      else if (this.$route.path == "/Home/Personal") {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        this.$store.commit("activeIndex", 9);
      }
      else if (this.$route.path == "/Home/CloudPhoto") {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        this.$store.commit("activeIndex", 8);
      }
      else if (this.$route.path == "/Home/Exhibition") {
        this.$store.commit("activeIndex", 3);
      } else if (this.$route.path == "/Home/CloudGuide") {
        this.$store.commit("activeIndex", 2);
      } else {
        if (this.$route.query.mode == "id1") {
          this.$store.commit("activeIndex", 1);
        } else if (this.$route.query.mode == "id2") {
          this.$store.commit("activeIndex", 2);
        } else if (this.$route.query.mode == "id3") {
          this.$store.commit("activeIndex", 3);
        } else if (this.$route.query.mode == "id4") {
          this.$store.commit("activeIndex", 4);
        } else if (this.$route.query.mode == "id5") {
          this.$store.commit("activeIndex", 5);
        } else if (this.$route.query.mode == "id7") {
          this.$store.commit("activeIndex", 7);
        } else if (!this.$route.query.mode) {
          document.body.scrollTop = document.documentElement.scrollTop = 0;
          this.$store.commit("activeIndex", 0);
        }
      }

      const _this = this;
      document.addEventListener("click", function (e) {
        if (document.documentElement.clientWidth < 768) {
          const Icon = document.getElementsByClassName("icon-nav");
          if (Icon[0] === e.target && _this.navMobile) {
            _this.navMobile = true;
          } else {
            _this.navMobile = false;
          }
        }
      });
    },
    hadnleLogo() {
      let params = this.$route.query;
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.$store.commit("activeIndex", 0);
      this.$router.push({
        path: "/Home/Index",
        query: {
          backlink: encodeURIComponent(window.location.href),
          track: params.track ? params.track : "",
          utm_source: params.utm_source ? params.utm_source : "",
          utm_medium: params.utm_medium ? params.utm_medium : "",
          utm_campaign: params.utm_campaign ? params.utm_campaign : "",
          utm_content: params.utm_content ? params.utm_content : "",
          se_sr: params.se_sr ? params.se_sr : "",
          se_md: params.se_md ? params.se_md : "",
          se_ct: params.se_ct ? params.se_ct : "",
        },
      });
    },
    handleSelect(index, path, id, ispath, ga) {
      let pageName = "";
      switch (index) {
        case 0:
          pageName = "首页";
          break;
        case 1:
          pageName = "首页-大会日程";
          break;
        case 2:
          pageName = "首页-云导览";
          break;
        case 3:
          pageName = "首页-新品展示";
          break;
        case 4:
          pageName = "首页-下载中心";
          break;
        case 5:
          pageName = "首页-行业云展厅";
          break;
        case 7:
          pageName = "首页-参会指南";
          break;
      }
      if (pageName) {
        GetUserLogs({
          visitName: "页面访问-" + pageName,
          visitType: 1,
          url: window.location.href,
          track: this.$route.query.track ? this.$route.query.track : 7756
        });
      }
      var ga_Code = JSON.parse(JSON.stringify(ga));
      dataLayer.push(ga_Code);

      if (index == 0 || path !== "/Home/Index") {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
      }
      let params = this.$route.query;
      // setTimeout(() => {
      this.$router.push({
        path: path,
        query: {
          track: params.track ? params.track : "",
          utm_source: params.utm_source ? params.utm_source : "",
          utm_medium: params.utm_medium ? params.utm_medium : "",
          utm_campaign: params.utm_campaign ? params.utm_campaign : "",
          utm_content: params.utm_content ? params.utm_content : "",
          se_sr: params.se_sr ? params.se_sr : "",
          se_md: params.se_md ? params.se_md : "",
          se_ct: params.se_ct ? params.se_ct : "",
          mode: id ? "id" + id : "",
        },
      });
      // },300)
      if (ispath) {
        // document.body.scrollTop = document.documentElement.scrollTop = 0;
      }
      // this.activeIndex = id;
      this.$store.commit("activeIndex", id);
    },
    navMo() {
      this.navMobile = !this.navMobile;
      this.shows = false;
    },
    nav_Moile() {
      this.navMobile = false;
    },
    navState1() {
      this.navMobile = true;
    },
    navState2() {
      this.navMobile = false;
    },
    Register() {
      let params = this.$route.query;
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.$router.push({
        name: "Register",
        query: {
          backlink: encodeURIComponent(window.location.href),
          track: params.track ? params.track : "",
          utm_source: params.utm_source ? params.utm_source : "",
          utm_medium: params.utm_medium ? params.utm_medium : "",
          utm_campaign: params.utm_campaign ? params.utm_campaign : "",
          utm_content: params.utm_content ? params.utm_content : "",
          se_sr: params.se_sr ? params.se_sr : "",
          se_md: params.se_md ? params.se_md : "",
          se_ct: params.se_ct ? params.se_ct : "",
        },
      });
    },
  },
  computed: {
    clientWidth() {
      return this.$store.state.clientWidth;
    },
    userInfo() {
      return this.$store.state.userInfo;
    },
    islogin() {
      return this.$store.state.islogin;
    },
  },
  watch: {
    "$store.state.activeIndex"(newval, oldval) {
      this.activeIndex = newval;
    },
    $route: {
      immediate: true,
      handler(newVal, oldVal) {
        this.getActive();
      },
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>